import { render, staticRenderFns } from "./DocumentTemplateNewForm.vue?vue&type=template&id=0cec7ced"
import script from "./DocumentTemplateNewForm.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports